import PropTypes from 'prop-types';
import useScrollPosition from '~/hooks/use-scroll-position';

const ScrollAware = ({ children, scrollingContainer }) => {
	const { scrollYPosition } = useScrollPosition(scrollingContainer);

	return children(scrollYPosition);
};

ScrollAware.propTypes = {
	scrollingContainer: PropTypes.oneOfType([PropTypes.instanceOf(Element), PropTypes.node]),
	children: PropTypes.func.isRequired
};

export default ScrollAware;
